<template>
  <div class="row">
    <div :class="isRouteMaximized ? 'col-12' : 'col-4'">
      <div 
        class="position-relative"
        :class="isRouteMaximized ? 'minify' : 'maxify'"
      >
        <img
          :src="route?.mapImageUrl"
          @click="toggleImageSize"
        >
        <i 
          v-if="!isRouteMaximized" 
          class="fa fa-search-plus magnifying-glass color-sachlich-white position-absolute" 
        />
      </div>
    </div>

    <div
      v-if="!isRouteMaximized"
      class="col"
    >
      <span class="fw-bold">{{ cruise?.startDate }} &ndash; {{ cruise?.endDate }}</span><br>
      <span class="fw-bold large lh-base">{{ routeNameUpperCase }}</span><br>
      <span>{{ cruise?.duration }}&nbsp;Tage {{ firstPortLastPort }}</span>
      <span>mit {{ ship?.name }}</span><br><br>
    </div>
  </div>
</template>

<script lang="ts">
import { useCruiseStore } from '@/store';
import { mapState } from 'pinia';
import { defineComponent } from 'vue';

export default defineComponent({
  emits: {
    click: null,
    'toggle-image-size': null
  },
  data: () => {
    return {
      imageSize: '180px',
      isRouteMaximized: false,
    }
  },

  computed: {
    ...mapState(useCruiseStore, {
      cruise: store => store.cruise,
      route: store => store.route,
      ship: store => store.ship,
    }),
    firstPort() {
      return this.route?.ports.at(0)
    },
    lastPort() {
      return this.route?.ports.at(-1)
    },
    firstPortLastPort() {
      if (this.firstPort === this.lastPort) {
        return `ab/bis ${this.firstPort}`
      }
      return `ab ${this.firstPort} bis ${this.lastPort}`
    },
    routeNameUpperCase() {
      return this.route?.name.toUpperCase()
    }
  },
  methods: {
    toggleImageSize() {
      this.isRouteMaximized = !this.isRouteMaximized
      this.imageSize = this.isRouteMaximized ? '440px' : '180px'
      this.$emit('toggle-image-size', this.isRouteMaximized)
    },
  },
})
</script>

<style lang="scss" scoped>
@import '../../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

.maxify {
  cursor: zoom-in;
}

.minify {
  cursor: zoom-out;
}

img {
  width: 100%;
  object-fit: contain;
}

.magnifying-glass {
  font-size: 20px;
  right: 7px;
  bottom: 7px;
}

.large {
  font-size: 14px;
}
</style>
